export default __webpack_public_path__ + "static/media/top-bar.d9f07946.webp";